import React from 'react'
import * as Styled from './Blocks.styles'

const CountdownTimer = ({ timeLeft, text }) => {
  const { days, hours, minutes } = timeLeft
  const dayString = `day${days !== 1 ? 's' : ''}`
  const hourString = `hour${hours !== 1 ? 's' : ''}`
  const minuteString = `min${minutes !== 1 ? 's' : ''}`
  const showDays = days > 0
  const showHours = hours > 0
  const showMinutes = minutes > 0

  return (
    <Styled.Wrapper>
      {text && <Styled.Text>{text}</Styled.Text>}
      <Styled.Blocks>
        {showDays && (
          <Styled.Block className="countdown-block">
            <Styled.Number>{days}</Styled.Number>{' '}
            <Styled.String>{dayString}</Styled.String>
          </Styled.Block>
        )}
        {showHours && (
          <Styled.Block className="countdown-block">
            <Styled.Number>{hours}</Styled.Number>{' '}
            <Styled.String>{hourString}</Styled.String>
          </Styled.Block>
        )}
        {showMinutes && (
          <Styled.Block className="countdown-block">
            <Styled.Number>{minutes}</Styled.Number>{' '}
            <Styled.String>{minuteString}</Styled.String>
          </Styled.Block>
        )}
      </Styled.Blocks>
    </Styled.Wrapper>
  )
}

export default CountdownTimer
